export enum PageUrl {
  HOMEPAGE = '/homepage.html',
  TEST_DRIVE = '/test-drive.html',
  TEST_DRIVE_PRE_SALE = '/presale-testdrive.html',
  DEALERS = '/dealers.html',
  PURCHASE = '/purchase/product-order-page.html',
  PURCHASE_FILTER = '/purchase/product-order-page.html#/filter',
  VEHICLES = '/vehicles',
  CAR_COMPARISON_ENGINE = '/car-comparison/engine',
  CAR_COMPARISON_MODEL = '/car-comparison/model',
  MODEL_FILTER = '/model-filter.html',
  VAN_CONFIGURATOR = '/van-configurator.html',
  CAMPAIGN = '/campaigns',
  CAMPAIGN_PURCHASE = '/campaigns/purchase.html',
  SPECIALOFFER = '/special-offer',
  USED_CAR = '/usedcar',
  USED_CAR_STOCK = '/usedcar/stock/#/',
  FINANCE_CALCULATOR = '/financial-calculator.html',
  MMC_HOMEPAGE = '/mmc/index.html',
  MMC_PRODUCT = '/mmc-storefront/#/product',
  SETTING = '/setting.html',
  SEARCH_RESULT = '/search',
  ENVIRONMENTAL_PROTECTION_INFORMATION = '/environmental-protection-information.html',
  SITE_MAP = '/site-map.html',
  FAVORITES = '/myfavorites.html',
  RECALL_INFORMATION = '/recall-information.html',
}

